import { render, staticRenderFns } from "./OrgHomeStats.vue?vue&type=template&id=d06389e4&scoped=true&"
import script from "./OrgHomeStats.vue?vue&type=script&lang=js&"
export * from "./OrgHomeStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06389e4",
  null
  
)

export default component.exports